import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const WE_CHAT_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.WeChatPay,
    name: 'wechatpay',
    displayName: 'WeChat Pay'
};
